import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { useGetColumns } from '../../MisVisitasContrato/hooks/useGetColumns';
import { useGetRows } from '../../MisVisitasContrato/hooks/useGetRows';
import { CabeceraContratoContent } from './CabeceraContratoContent';
import CardBox from "../../MisVisitasCreation/components/components/CardBox/CardBox";
import { CustomButton } from '../../../components/customButton/CustomButton';
import { useGetFilters } from '../../MisVisitasContrato/hooks/useGetFilters';
import moment from 'moment'
import { useActions } from '../hooks/useActions';
import { GET_PROFESIONAL_LOGGED } from "../../../data/graphQL/queries/MisVisitas/getProfesionalLogged";
import { useQuery } from '@apollo/client/react';
import toast from 'react-hot-toast';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';

export const VisitasContratoContent = () => {
    const [infoGeneral, setInfoGeneral] = useState({});
    const [idProfesional, setIdProfesional] = useState(0);
    const { data: profesionalLogged } = useQuery(GET_PROFESIONAL_LOGGED, {
        fetchPolicy: 'no-cache',
    });

    useEffect(() => {
        if (!!profesionalLogged) {
            setIdProfesional(profesionalLogged?.profesionalByIdUsuario?.idProfesional);
        }
    }, [profesionalLogged]);

    const navigate = useNavigate();
    const location = useLocation();

    const {
        idEvaluacion,
        idPaciente,
        codigoSAP,
        paciente,
        programa,
        planCuidado,
        periodoSuspension,
        profesional,
        idTipoProfesional,
        idFiguraProfesional,
        figuraProfesional,
        idTipoModulo,
        idFrecuencia,
        estado,
        estadoPaciente,
        direccion,
        mes,
        anio,
        frecuencia,
        fechaAsignacion,
        fechaDesde,
        fechaHasta,
        cantidadVisitas,
        cantidadVisitasEsperadas,
        urgencias,
        cantidadNotificaciones,
        misVisitas
    } = location.state;

    useEffect(() => {
        setInfoGeneral((prevInfo) => ({
            ...prevInfo,
            idEvaluacion: idEvaluacion,
            idPaciente: idPaciente,
            codigoSAP: codigoSAP,
            paciente: paciente,
            programa: programa,
            planCuidado: planCuidado,
            profesional: profesional,
            estado: estado,
            estadoPaciente: estadoPaciente,
            periodoSuspension: periodoSuspension,
            direccion: direccion,
            mes: mes,
            anio: anio,
            frecuencia: frecuencia,
            fechaAsignacion: fechaAsignacion,
            fechaDesde: fechaDesde,
            fechaHasta: fechaHasta,
            cantidadVisitas: cantidadVisitas,
            cantidadVisitasEsperadas: cantidadVisitasEsperadas,
            urgencias: urgencias,
            cantidadNotificaciones: cantidadNotificaciones,
            figuraProfesional: figuraProfesional
        }));
    }, [location.state]);

    const {
        idProfesionalSelected,
        idTipoProfesionalSelected,
        idFiguraProfesionalSelected,
        figuraProfesionalSelected,
        profesionales,
        handleProfesionalChange
    } = useGetFilters(idEvaluacion);

    async function tieneGeoHabilitada() {
        if (!("geolocation" in navigator)) {
            return false;
        }

        if ("permissions" in navigator) {
            try {
                const permissionStatus = await navigator.permissions.query({ name: "geolocation" });

                if (permissionStatus.state === "granted") {
                    return true;
                }

                if (permissionStatus.state === "denied") {
                    return false;
                }
                // state === "prompt": el usuario nunca ha respondido
                // En este caso caemos al fallback con getCurrentPosition
            } catch (e) {
                // Permissions API no soportada, usar fallback
            }
        }

        // Fallback: intentar obtener ubicación directamente
        return new Promise((resolve) => {
            const timeoutMs = 10000;

            const timeoutId = setTimeout(() => resolve(false), timeoutMs + 500); // Ligero margen

            navigator.geolocation.getCurrentPosition(
                () => {
                    clearTimeout(timeoutId);
                    resolve(true);
                },
                (error) => {
                    clearTimeout(timeoutId);
                    resolve(error.code !== error.PERMISSION_DENIED);
                },
                {
                    timeout: timeoutMs,
                    maximumAge: 30000,
                    enableHighAccuracy: false,
                }
            );
        });
    }

    const handleClickNueva = async () => {
        const tieneGeo = await tieneGeoHabilitada();
        if (!tieneGeo) {
            toast.error("Debe habilitar el permiso de ubicación en su navegador para crear una nueva visita.", {
                duration: 4000
            });
            return;
        }
        navigate('/misVisitas/nuevaVisita', {
            state: {
                isNew: true,
                idVisita: 0,
                idPaciente: infoGeneral?.idPaciente,
                idProfesional: idProfesional,
                idTipoProfesional: idTipoProfesional,
                idFiguraProfesional: idFiguraProfesional,
                figuraProfesional: figuraProfesional,
                idTipoModulo: idTipoModulo,
                idEvaluacion: infoGeneral?.idEvaluacion,
                programa: infoGeneral?.programa,
                idFrecuencia: idFrecuencia,
                visitasProgramadas: `${cantidadVisitas}/${cantidadVisitasEsperadas}`,
                periodo: `(${fechaAsignacion})`,
            },
        });
    }

    const {
        rows,
        setRows,
        loading,
        totalCount,
        handleSearch
    } = useGetRows(idEvaluacion,
        idPaciente,
        misVisitas,
        fechaDesde,
        fechaHasta,
        idFrecuencia,
        idProfesional,
        idProfesionalSelected,
        idTipoProfesional,
        idTipoProfesionalSelected,
        idFiguraProfesional,
        idFiguraProfesionalSelected,
        figuraProfesionalSelected,
        figuraProfesional
    );
    const {
        handleClickView,
        handleClickEdit,
        handleClickDelete,
        handleCancelDelete,
        onConfirmDelete,
        openConfirmDelete
    } = useActions(
        handleSearch,
        `${cantidadVisitas}/${cantidadVisitasEsperadas}`,
        `(${fechaAsignacion})`,
        tieneGeoHabilitada
    );

    const columns = useGetColumns(
        misVisitas,
        handleClickView,
        handleClickEdit,
        handleClickDelete,
    );

    return (
        <>
            <div>
                <CabeceraContratoContent
                    infoGeneral={infoGeneral}
                    profesionales={profesionales}
                    misVisitas={misVisitas}
                    idProfesionalSelected={idProfesionalSelected}
                    idTipoProfesionalSelected={idTipoProfesionalSelected}
                    handleProfesionalChange={handleProfesionalChange}
                />
                <CardBox>
                    {misVisitas && <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
                        <CustomButton
                            onClick={handleClickNueva}
                            size='small'
                            variant='outlined'
                            disabled={moment().isAfter(moment(fechaHasta).add(2, "days"), "day") || moment().isBefore(moment(fechaDesde))}
                        >
                            Nueva
                        </CustomButton>
                    </div>}
                    <DataGridGenerico
                        sx={{ width: '100%' }}
                        entityId={'idVisita'}
                        columns={columns}
                        totalCount={totalCount}
                        rows={rows}
                        toolbar={false}
                        loading={loading}
                    />
                </CardBox>
            </div>
            <CustomDialog
                maxWidth='sm'
                fullWidth
                onCancel={handleCancelDelete}
                onAccept={onConfirmDelete}
                open={openConfirmDelete.open}
                acceptText='Si, Eliminar'
                cancelText='Cancelar'
                title='¿Está seguro que desea eliminar la visita?'>
            </CustomDialog>
        </>
    );
}